// extracted by mini-css-extract-plugin
export default {"sessionItem":"SessionItem_sessionItem__+YqEn","selected":"SessionItem_selected__9uf3M","chatIcn":"SessionItem_chatIcn__L0Rvq"};